// extracted by mini-css-extract-plugin
export default {"imageContainer":"_3_lBnnBt","zoom":"_2T1hxAef","hiddenImage":"_2-M7BcG2","backgroundDiv":"_1OuTWpR2","backgroundLoaded":"_1n_0mdTw","zoomIcon":"f7gfVDHY"};